import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm, formValueSelector, submit, reset } from "redux-form";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Alert,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
  Form,
  FormGroup,
  FormFeedback,
  Input
} from "reactstrap";
import { DataTable, ExportCSV } from "../../../components";
import { getFranchiseReport } from "../../../store/dashboard/actions";
import { getFranchiseDetail } from "../../../service/dashboard";
import { generateBilling, resetGenerateBilling, getFranchiseBilling, resetFranchiseBilling } from "../../../store/franchise/actions";
import Select from "react-select";
import * as columns from "./_columns";
import { messages, layout, months } from "../../../common/constants";
import MediaQuery from "react-responsive";
import { formatHelper, selectHelper, validationHelper, normalizeHelper } from "../../../common/helpers";
import { selectUserRole } from "../../../store/user/selector";
import { toast } from 'react-toastify'

class Franchise extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      selectedMonth: null,
      selectedYear: null,
      showReport: false,
      franchiseExport: [],
      isOpen: false,
      franchiseItem: null,
      franchiseBilling: null,
    };

    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleMonthChange = this.handleMonthChange.bind(this);
    this.handleYearChange = this.handleYearChange.bind(this);
    this.handleObtainFranchiseExport = this.handleObtainFranchiseExport.bind(
      this
    );
    this.handleExportCSV = this.handleExportCSV.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
    this.renderBillingTypesField = this.renderBillingTypesField.bind(this);

    this.onModalSubmit = this.onModalSubmit.bind(this)
  }

  componentDidUpdate(prevProps) {
    this.checkFranchiseBilling(prevProps)
  }

  componentWillUnmount() {
    this.props.resetFranchiseBilling();
    this.props.resetGenerateBilling()
  }

  checkFranchiseBilling(prevProps) {
    if (prevProps.billingSuccess == null && this.props.billingSuccess != null) {
      window.open(this.props.billingSuccess)
      toast.success("Facturación realizada correctamente")
    }

    if (prevProps.billingError == null && this.props.billingError != null) {
      toast.error(this.props.billingError)
    }
  }


  performGetFranchiseReport(reset = false) {
    const { selectedMonth, selectedYear, page } = this.state;
    this.props.getFranchiseReport({
      month: selectedMonth.value,
      year: selectedYear.value,
      page,
      reset
    });
  }

  async handlePageChange(page) {
    if (this.state.page == page) return;
    await this.setState({ page: page });
    this.performGetFranchiseReport();
  }

  async handleMonthChange(value) {
    await this.setState({ selectedMonth: value });

    if (!this.state.selectedMonth || !this.state.selectedYear) return;
    await this.setState({ showReport: true });
    this.performGetFranchiseReport();
  }

  async handleYearChange(value) {
    await this.setState({ selectedYear: value });

    if (!this.state.selectedMonth || !this.state.selectedYear) return;
    await this.setState({ showReport: true });
    this.performGetFranchiseReport();
  }

  renderDataTable(columns) {
    return (
      <DataTable
        data={this.props.franchiseReport}
        keyField="id"
        columns={columns}
        page={this.state.page}
        totalSize={this.props.total}
        sizePerPage={Number(this.props.pageSize)}
        loading={this.props.loading}
        onPageChange={this.handlePageChange}
      />
    );
  }

  async handleObtainFranchiseExport() {
    await getFranchiseDetail(
      this.state.selectedMonth.value,
      this.state.selectedYear.value,
      0
    ).then(response => {
      this.setState({
        franchiseExport: response.data.data
      });
    });
    this.handleExportCSV();
  }

  handleExportCSV() {
    var csvRow = [];
    var A = [
      [
        "Tienda",
        "RUC",
        "Venta",
        "Franquicia",
        "Publicidad",
        "Tecnología",
        "Total"
      ]
    ];
    var re = this.state.franchiseExport;
    var month = this.state.selectedMonth.label;
    var year = this.state.selectedYear.label;

    for (var item = 0; item < re.length; item++) {
      A.push([
        re[item].name,
        re[item].ruc,
        formatHelper.toMoney(re[item].total_sell),
        formatHelper.toMoney(re[item].franchise),
        formatHelper.toMoney(re[item].publicity),
        formatHelper.toMoney(re[item].technology),
        formatHelper.toMoney(re[item].total)
      ]);
    }
    for (var item = 0; item < A.length; item++) {
      csvRow.push(A[item].join(","));
    }
    var csvString = csvRow.join("\r\n");
    month = String(month).replace(/\s/g, "_");
    year = String(year).replace(/\s/g, "_");

    var a = document.createElement("a");
    a.href =
      "data:attachment/csv;charset=utf-16le,%EF%BB%BF" + encodeURI(csvString);
    a.target = "_Blank";
    a.download =
      "reporte-franquicia_" +
      month.toLowerCase() +
      "_" +
      year.toLowerCase() +
      ".csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  async handleOnClick(item) {
    await this.setState({ isOpen: true });
    await this.setState({ franchiseItem: item });
  }

  handleSelectChange(e) {
    const value = e.target.value
    const { franchiseItem, selectedMonth, selectedYear } = this.state
    this.props.getFranchiseBilling(value, selectedMonth.value, selectedYear.value)
    if (value == "Franquicia")
      this.props.change('amount', (Math.round(franchiseItem.franchise * 100) / 100).toFixed(2));
    else if (value == "Publicidad")
      this.props.change('amount', (Math.round(franchiseItem.publicity * 100) / 100).toFixed(2));
    else if (value == "Tecnología")
      this.props.change('amount', (Math.round(franchiseItem.technology * 100) / 100).toFixed(2));

  }

  renderBillingTypesField(field) {
    const {
      input,
      meta: { touched, error }
    } = field;
    const hasError = touched && error ? true : false;
    const { onChange } = input;
    const _onChange = e => {
      onChange(e)
      this.handleSelectChange(e)
    }
    return (
      <FormGroup row>
        <Col md="3" lg="3">
          <Label htmlFor="select">Tipo *:</Label>
        </Col>
        <Col xs="12" md="8" lg="8">
          <Input {...field.input} type="select" invalid={hasError} onChange={_onChange}>
            <option key={0} value={0}>
              Seleccione...
            </option>
            <option key={"Franquicia"} value={"Franquicia"}>
              Franquicia
            </option>
            <option key={"Publicidad"} value={"Publicidad"}>
              Publicidad
            </option>
            <option key={"Tecnología"} value={"Tecnología"}>
              Tecnología
            </option>
          </Input>
          {hasError == true ? <FormFeedback>{error}</FormFeedback> : null}
        </Col>
      </FormGroup>
    );
  }

  renderInputField(field) {
    const {
      meta: { touched, error }
    } = field;
    const hasError = touched && error ? true : false;
    const labelClass = field.labelClass ? field.labelClass : "mt-1";

    return (
      <FormGroup row>
        <Col md="3" lg="3">
          <Label className={labelClass}>{field.label}</Label>
        </Col>
        <Col xs="12" md="8" lg="8">
          <Input {...field.input} invalid={hasError} type={field.type} />
          {hasError == true ? <FormFeedback>{error}</FormFeedback> : null}
        </Col>
      </FormGroup>
    );
  }


  renderBillingModal() {
    const { handleSubmit, activeFranchiseBilling, activeFranchiseBillingLoading } = this.props;

    return (
      <Modal isOpen={this.state.isOpen} >
        <ModalHeader>Facturación</ModalHeader>
        <Form onSubmit={handleSubmit(handleSubmit(this.onModalSubmit))}>
          <ModalBody>
            <Field name="billing_type" component={this.renderBillingTypesField} />
            <Field
              name="amount"
              label="Monto *:"
              type="text"
              component={this.renderInputField}
              normalize={normalizeHelper.noSpecialsField()}
            />
            {activeFranchiseBilling &&
              <FormGroup row>
                <Col md="3" lg="3">

                </Col>
                <Col xs="12" md="8" lg="8">
                  <a target="_blank" href={activeFranchiseBilling.pdf_link}>Visualizar Factura en PDF</a>
                </Col>
              </FormGroup>}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" disabled={activeFranchiseBillingLoading == true | activeFranchiseBilling != null} >Facturar</Button>
            <Button
              color="secondary"
              onClick={() => {
                this.props.reset();
                this.setState({ isOpen: false, franchiseItem: null });
                this.props.resetFranchiseBilling();
              }}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </Form>

      </Modal>
    )
  }

  onModalSubmit(values) {
    const { selectedMonth, selectedYear, franchiseItem } = this.state;
    values.month = selectedMonth.value;
    values.year = selectedYear.value;
    values.store_id = franchiseItem.id
    values.amount = Number(values.amount)
    this.props.generateBilling(values)
    this.setState({ isOpen: false, franchiseItem: null });
    this.props.reset()
  }

  render() {
    return (
      <div>
        <Card>
          <CardHeader>
            <i className="icon-doc"></i>Franquicia
          </CardHeader>
          <CardBody>
            <Row className="mb-2">
              <Col md="4">
                <Row>
                  <Col md="4">
                    <Label className="mt-2">MES:</Label>
                  </Col>
                  <Col md="8">
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isSearchable={true}
                      noOptionsMessage={() => {
                        return messages.SELECT_NO_OPTIONS;
                      }}
                      placeholder="MES"
                      options={this.props._months}
                      loadingMessage={() => {
                        return messages.SELECT_LOADING;
                      }}
                      onChange={this.handleMonthChange}
                      value={this.state.selectedMonth}
                    />
                  </Col>
                </Row>
              </Col>
              <Col md="4">
                <Row>
                  <Col md="4">
                    <Label className="mt-2">AÑO:</Label>
                  </Col>
                  <Col md="8">
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isSearchable={true}
                      noOptionsMessage={() => {
                        return messages.SELECT_NO_OPTIONS;
                      }}
                      placeholder="AÑO"
                      options={this.props.years}
                      loadingMessage={() => {
                        return messages.SELECT_LOADING;
                      }}
                      onChange={this.handleYearChange}
                      value={this.state.selectedYear}
                    />
                  </Col>
                </Row>
              </Col>
              <Col md="4">
                {this.state.selectedMonth && this.state.selectedYear ? (
                  <ExportCSV
                    exportCSV={this.handleObtainFranchiseExport}
                    minWidth={layout.MD_MIN_WIDTH}
                  />
                ) : null}
              </Col>
            </Row>

            <hr className="my-4" />
            {this.state.showReport ? (
              <Row>
                <Col>
                  <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                    {this.renderDataTable(
                      columns.franchiseReportXS(
                        this.props.role,
                        this.handleOnClick
                      )
                    )}
                  </MediaQuery>
                  <MediaQuery
                    minWidth={layout.SM_MIN_WIDTH}
                    maxWidth={layout.MD_MAX_WIDTH}
                  >
                    {this.renderDataTable(
                      columns.franchiseReportSM(
                        this.props.role,
                        this.handleOnClick
                      )
                    )}
                  </MediaQuery>
                  <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                    {this.renderDataTable(
                      columns.franchiseReport(
                        this.props.role,
                        this.handleOnClick
                      )
                    )}
                  </MediaQuery>
                </Col>
              </Row>
            ) : (
                <Row>
                  <Col>
                    <Alert color="info">Seleccione un mes y año</Alert>
                  </Col>
                </Row>
              )}
          </CardBody>
        </Card>
        {this.renderBillingModal()}
      </div>
    );
  }
}

function validate(values) {
  const errors = {};

  if (validationHelper.stringIsNullOrEmpty(values.billing_type) || values.billing_type == "0") {
    errors.billing_type = messages.MANDATORY_FIELD;
  }

  if (validationHelper.stringIsNullOrEmpty(values.amount)) {
    errors.amount = messages.MANDATORY_FIELD;
  } else if (values.amount == "0")
    errors.amount = "Monto incorrecto";

  return errors;
}



function mapStateToProps(state) {
  const {
    franchiseReport,
    total,
    pageSize,
    error,
    loading
  } = state.dashboard.franchiseReportList;

  const {
    pdf_link: billingSuccess,
    error: billingError,
    loading: billingLoading
  } = state.franchise.franchiseBilling;

  const {
    franchiseBilling: activeFranchiseBilling,
    error: activeFranchiseBillingError,
    loading: activeFranchiseBillingLoading
  } = state.franchise.activeFranchiseBilling;

  return {
    franchiseReport,
    total,
    pageSize,
    error,
    loading,
    _months: months,
    years: selectHelper.getYearsForSelect(),
    role: selectUserRole(state),
    billingSuccess,
    billingError,
    billingLoading,
    activeFranchiseBilling,
    activeFranchiseBillingError,
    activeFranchiseBillingLoading
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getFranchiseReport,
      generateBilling,
      resetGenerateBilling,
      getFranchiseBilling,
      resetFranchiseBilling
    },
    dispatch
  );
}

export default reduxForm({
  form: "FranchiseBillingForm",
  touchOnBlur: false,
  validate,
})(
  connect(mapStateToProps, mapDispatchToProps)(Franchise)
);



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/Franchise/Franchise.js